<div class="page-wrap d-flex flex-row align-items-center"
    style="min-height:100vh;background-color:#3a5161;opacity:0.95">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-5 text-center card">
                <div [ngSwitch]="lastError" class="m-lg-4">
                    <div *ngSwitchCase="'invalidParams'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'MISSING-FHIR-AUTH-CODE', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'invalidState'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'INVALID-FHIR-AUTH-STATE', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'errorTokenRequest'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'ERROR-FHIR-EHR-PROFILE-CHECK', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'errorProfileCheck'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'ERROR-FHIR-AUTH-REQUEST', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'invalidTokenResponse'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'ERROR-FHIR-AUTH-RESPONSE', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'invalidAuth'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'INVALID-FHIR-AUTH', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'invalidAuthToken'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'ERROR-FHIR-TOKEN', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchDefault class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'FHIR-AUTH', class:'fa-sign-in-alt'}">
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #statusTemplate let-key='key' let-class='class'>
    <div class="col-1">
        <i class="fas {{class}} fa-2x"></i>
    </div>
    <div class="col-11">
        <span [innerHTML]="key | translate | safe:'html'" class="montserrat"></span>
    </div>
</ng-template>

<!--Select Active Roles Dialog-->
<app-select-role #selectRole></app-select-role>

<!--Select Active Organizations Dialog-->
<app-select-organization #selectOrganization></app-select-organization>